import { lazy } from 'react';

export const NotificationPageLazy = lazy(() => import('./NotificationPage'));
